import { render, staticRenderFns } from "./AdminTable.vue?vue&type=template&id=20a8abc8&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=ts"
export * from "./AdminTable.vue?vue&type=script&lang=ts"
import style0 from "./AdminTable.vue?vue&type=style&index=0&id=20a8abc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8abc8",
  null
  
)

export default component.exports